<div
  data-bs-toggle="tooltip"
  data-bs-original-title="Alan Warden"
  data-kt-initialized="1"
  class="mb-2 me-6 symbol symbol-40px"
>
  <span
    class="symbol-label bg-warning text-inverse-warning fw-bold"
    >A</span
  >
</div>
